var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsInt, IsNumber, IsOptional, IsString, Max, Min, } from 'class-validator';
import { OfficeProductLineItemFullSizeDto } from '../../custom-office-product-line-item/index.js';
import { OfficeProductType } from '../enums/office-product-type.enum.js';
export class UpdateOfficeProductDto {
    /**
     * The display name of the office product.
     */
    name;
    /**
     * The price of the office product in euro-cents.
     */
    price;
    /**
     * The short description of the office product.
     */
    description;
    image;
    /**
     * True if the office product is visible for patients.
     */
    visible;
    /**
     * The type of the office product.
     */
    type;
    /**
     * The number of therame video calls included in the product.
     */
    therameVideoCallCount;
    /**
     * The number of therame exercise programs included in the product.
     */
    therameExerciseProgramCount;
    /**
     * The number of days until the product expires.
     */
    expirationDays;
    officeProductLineItems;
}
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeProductDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    Min(1),
    Max(9999999900),
    __metadata("design:type", Number)
], UpdateOfficeProductDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeProductDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeProductDto.prototype, "image", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateOfficeProductDto.prototype, "visible", void 0);
__decorate([
    IsEnum(OfficeProductType),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeProductDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeProductDto.prototype, "therameVideoCallCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateOfficeProductDto.prototype, "therameExerciseProgramCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    Max(365),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateOfficeProductDto.prototype, "expirationDays", void 0);
__decorate([
    Expose(),
    IsArray(),
    IsOptional(),
    Type(() => OfficeProductLineItemFullSizeDto),
    __metadata("design:type", Array)
], UpdateOfficeProductDto.prototype, "officeProductLineItems", void 0);
//# sourceMappingURL=update-office-product.dto.js.map